module.exports = __webpack_public_path__ + "static/media/PeriodicallyRunCleanBlue.81d27350.svg";